// No role fallback: migrated modules use the effective permissions returned by API.
export const hasPermission = (user, permission) =>
  Array.isArray(user?.permissions) && user.permissions.includes(permission);
